/**
 * 02/06/2026 — BUG FIX (React error #185 in production).
 *
 * Stable empty fallbacks for Zustand selectors. When you write
 *
 *   useGameStore(s => s.X || [])
 *
 * with X undefined, the selector returns a NEW `[]` reference on every
 * render. Zustand sees the output as "changed" → triggers a re-render →
 * produces another new `[]` → infinite loop → React error #185
 * "Maximum update depth exceeded". The bug only manifests in production
 * (minified, no dev warnings) and on saves/states where the slice
 * hasn't populated the field yet (legacy data, fresh phase).
 *
 * Rule : ALWAYS use one of these constants as the fallback in a
 * Zustand selector. Object.freeze guarantees the reference cannot be
 * mutated and stays identical across renders.
 *
 *   ✅  useGameStore(s => s.X || EMPTY_ARRAY)
 *   ❌  useGameStore(s => s.X || [])
 */

export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
